import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.HTFSetup.title',
    defaultMessage: 'HTF',
  },
  fixed: {
    id: 'App.ViewProperty.AffordableSetup.HTFSetup.fixed',
    defaultMessage: 'Fixed',
  },
  floating: {
    id: 'App.ViewProperty.AffordableSetup.HTFSetup.floating',
    defaultMessage: 'Floating',
  },
  none: {
    id: 'App.ViewProperty.AffordableSetup.HTFSetup.none',
    defaultMessage: 'None',
  },
});

export default messages;
